// JsFromRoutes CacheKey edc4e12c2cab586bd36a8b5abb47f88f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const reservationRequests = {
  create: definePathHelper("post", "/reservation_requests"),
};
